import strings from 'localization/strings';

const contactUsCategories = {
    booking: {},
    emergency: {},
    general: {}
};

Object.keys(contactUsCategories).forEach(key => {
    contactUsCategories[key].key = key;
});

strings.addLoadCallback(() => {
    Object.values(contactUsCategories).forEach(o => {
        o.title = strings.contactUsCategories[o.key].title;
        o.examples = strings.contactUsCategories[o.key].examples;
        o.description = strings.contactUsCategories[o.key].description;
    });
});

export default contactUsCategories;
